import { Search } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { SearchPatientList } from 'Global/Adapters/SearchPatientList';
import EditableCustomizableSelect from 'Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect';
import EditablePersianSupportTextField from 'Global/Components/EditableComponents/EditablePersianSupportTextField';
import PersianSupportNumericTextField from 'Global/Components/UnEditableComponents/PersianSupportNumericTextField/PersianSupportNumericTextField';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import i18next from 'i18next';
import React, { useState } from 'react';

const PatientSearchTextBox = (props) => {
  const {
    searchBase_label,
    searchBase_dataArray,
    setSearchMode,
    searchMode,
    HandleGatherData,
    initialData,
    setShowForm,
    showSearchBox,
    setShowSearchBox,
  } = props;

  const addNewPatient_label = FindLangKey(
    'save-patients-for-visit-add-new-patient-btn'
  );

  // console.log(
  //   'searchMode[0]?.ItemValue---->',
  //   searchMode[0]?.ItemValue
  // );

  return (
    <React.Fragment>
      <Stack gap=".5em">
        {showSearchBox ? (
          <Button
            variant="contained"
            color="colorPrimer"
            sx={{
              color: `${themeColors.ColorPrimary} !important`,
            }}
            onClick={() => {
              setShowSearchBox((prev) => !prev);
              setShowForm(true);
            }}
          >
            {addNewPatient_label}
          </Button>
        ) : (
          <></>
        )}
        {showSearchBox ? (
          <>
            <EditableCustomizableSelect
              isSingle={true}
              isEnglish={i18next.language === 'en'}
              label={searchBase_label}
              SelectableDataArray={searchBase_dataArray}
              initialData={initialData}
              CompleteOutPut={true}
              onChange={setSearchMode}
              enableInitialOnchange={true}
            />
            {searchMode[0]?.ItemValue ===
            ('NationalCode' ||
              'IdPatient' ||
              'FileNo' ||
              'MobileNumber') ? (
              <PersianSupportNumericTextField
                label={
                  searchMode && searchMode[0]?.ItemContent
                }
                icon={<Search />}
                iconFn={(
                  formattedValue,
                  onChange,
                  callbackFn
                ) => {
                  SearchPatientList(
                    formattedValue,
                    onChange,
                    callbackFn,
                    searchMode[0]?.ItemValue
                  );
                  setShowForm();
                }}
                callbackFn={HandleGatherData}
                isOctalAllowed={true}
                isEnglish={i18next?.language === 'en'}
              />
            ) : (
              <EditablePersianSupportTextField
                label={
                  searchMode && searchMode[0]?.ItemContent
                }
                icon={<Search />}
                iconFn={(
                  formattedValue,
                  onChange,
                  callbackFn
                ) => {
                  SearchPatientList(
                    formattedValue,
                    onChange,
                    callbackFn,
                    searchMode[0]?.ItemValue
                  );
                  setShowForm();
                }}
                callbackFn={HandleGatherData}
                isEnglish={i18next?.language === 'en'}
              />
            )}
          </>
        ) : (
          <></>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default PatientSearchTextBox;
